"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelSegmentPercentage = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.TravelSegmentPercentage = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.travel_segment_percentage.label',
    fallbackLabel: 'Please specify the volume split in % of your total portfolio if you intend to offer Klarna\'s payment services to Travel or Event Broker/Agent (e.g., Online Travel Agency).',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Number,
    mfValidation: {
        pathToValidation: 'base/volumeSplit',
    },
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
